const COMPLETE_STATUS_LIST = [
  "automated",
  "reviewed",
  "needs review",
  "reviewed",
  "validated",
  "needs eligibility review",
  "eligibility cleared",
  "validated",
];

const credentialsCategory = ["Certifications", "Licensure"]

const credentialsCategoryV2 = [
  "Certifications", "Licensure","Health Documents","Employment Documents"
]

const typeList = [
  { label: "Registered Nurse", value: "RN" },
  { label: "Licensed Practical Nurse", value: "LPN" }
]; 

export {COMPLETE_STATUS_LIST ,credentialsCategory,credentialsCategoryV2, typeList};
